export const LOCALE = 'en';

export const TRANSLATIONS = new Map(
  Object.entries({
    'menu.tableau': 'Dashboard',
    'menu.accueil': 'Home',
    'menu.utilisateurs': 'Users',
    'menu.distributeurs': 'Organisations',
    'menu.campagnes': 'Season',
    'menu.exploitations': 'Farms',
    'menu.parcelles': 'Fields',
    'menu.commandes': 'Orders',
    'menu.planning': 'Planning',
    'menu.conseils': 'Recommendations',
    'menu.machinisme': 'Machinism',
    'menu.exports': 'Exports',
    'menu.visualizer': 'My visualizer',

    'login.profil': 'Profile',
    'login.logout': 'Log out',

    'home.welcome': (name: string) => `Welcome to your ${name} profile,`,
    'home.subwelcome.html': 'Your nitrogen <b>management</b> and <b>variable-rate</b> tool for cereals and rapeseed.',
    'home.contactus': 'We look forward to hearing from you:',
    'home.tel.html': (tel: string) => `by telephone on <b>${tel}</b>`,
    'home.mail.html': (mail: string) => `by e-mail at <b>${mail}</b>`,
    'home.openhours.week': 'monday-friday : 8am-6pm',
    'home.openhours.weekend': 'saturday : 9am-5pm',

    'me.profile': 'My profile',
    'me.login': 'Login',
    'me.nom': 'Name',
    'me.distributeur': 'Organisation',
    'me.roles': 'Roles',
    'me.pays': 'Country',
    'me.tel': 'Phone',
    'me.mobile': 'Mobile',
    'me.conseiller': 'Consultant',
    'me.conseiller.email': 'Consultant email',
    'me.conseiller.mobile': 'Consultant mobile',

    'me.section': 'Profile',
    'me.edit.titre': 'Edit profile',
    'me.edit.login': 'Login',
    'me.edit.email': 'Contact email',
    'me.edit.distributeur': 'Organisation',
    'me.edit.prenom': 'First name',
    'me.edit.nom': 'Family name',
    'me.edit.pays': 'Country',
    'me.edit.tel': 'Phone',
    'me.edit.indicatif': 'Country code',
    'me.edit.numero': 'Number',
    'me.edit.mobile': 'Mobile',
    'me.edit.newmdp': 'New password',
    'me.edit.mdp': 'Password',
    'me.edit.mdpconfirm': 'Confirm password',
    'me.edit.mpdconfirm.error': 'The passwords do not match',

    'langue.edit': 'Edition of the language',
    'langue.edit.distrPays': 'Country of organisation',
    'langue.edit.distrDefaultLang': '(default language of the organisation)',
    'langue.edit.languageGui': 'Website language',
    'langue.edit.languagePdf': 'PDF language',
    'langue.edit.langue': 'Language',
    'langue.edit.reloadWarning': 'The website will reload after confirmation of this dialog',

    'distributeur.section': 'Organisations',
    'distributeur.table.filter.nom': 'organisation name',
    'distributeur.table.button.add': 'Add an organisation',
    'distributeur.table.nom': 'Name',
    'distributeur.table.none': 'No organisation to display',

    'distributeur.edit.creation': 'Add new organisation',
    'distributeur.edit.edition': 'Edit organisation',
    'distributeur.edit.nom': 'Name',
    'distributeur.edit.responsable': 'Organisation manager',
    'distributeur.edit.sector': 'Area manager',
    'distributeur.edit.negoce': 'Central purchasing manager',
    'distributeur.edit.logo': 'Send logo',
    'distributeur.edit.adresse': 'Address',
    'distributeur.edit.adrComp': 'Additional address',
    'distributeur.edit.cp': 'Postcode',
    'distributeur.edit.ville': 'City',
    'distributeur.edit.pays': 'Country',
    'distributeur.edit.tel': 'Phone',
    'distributeur.edit.i18n': 'Internationalisation (users can switch language) - default language if not checked',
    'distributeur.edit.beapi': 'BeAPI customer',
    'distributeur.edit.unauthorized': 'You are not authorized to edit this organisation',
    'distributeur.edit.view.unauthorized': 'You are not authorized to view this organisation',

    'user.section': 'Users',
    'user.table.filter.nom': 'user name or email',
    'user.table.filter.distributeur': 'organisation name',
    'user.table.filter.conseiller': 'advisor login',
    'user.table.button.add': 'Create user',
    'user.table.login': 'Login',
    'user.table.nom': 'Name',
    'user.table.distributeur': 'Organisation',
    'user.table.role': 'Role',
    'user.table.referent': 'Referent',

    'user.edit.creation': 'Create user',
    'user.edit.edition': 'Modify user',
    'user.edit.login': 'Email (login)',
    'user.edit.login.placeholder': 'Email',
    'user.edit.email': 'Contact email',
    'user.edit.prenom': 'First name',
    'user.edit.nom': 'Family name',
    'user.edit.pays': 'Country',
    'user.edit.tel': 'Phone',
    'user.edit.indicatif': 'Country code',
    'user.edit.numero': 'Number',
    'user.edit.mobile': 'Mobile',
    'user.edit.roleWanaka': 'Role within Wanaka',
    'user.edit.roleDistr': 'Role within the organisation',
    'user.edit.role': 'Role',
    'user.edit.distributeur': 'Organisation',
    'user.edit.manager.farmer': 'Advisor',
    'user.edit.manager.conseiller': 'Manager',
    'user.edit.unauthorized': 'You are not authorized to edit this user',
    'user.edit.error.exists_in_db': 'Unable to create user: An account with that login already exists',
    // FIXME remplacer WANAKA par chaine WL (était comme ça avant)
    'user.edit.error.exists_in_kc': "Unable to create user: Please contact WANAKA's support team",
    'user.edit.view.unauthorized': 'You are not authorized to view this user',

    'farm.section': 'Farms',
    'farm.table.filter.nom': 'farm name',
    'farm.table.filter.distributeur': 'organisation name',
    'farm.table.filter.conseiller': 'advisor login',
    'farm.table.button.add': 'Create farm',
    'farm.table.none': 'No farm to display',
    'farm.table.nom': 'Name',
    'farm.table.ville': 'City',
    'farm.table.cp': 'Postcode',
    'farm.table.login': 'Login',
    'farm.table.delete.error': 'This farm cannot be deleted',

    'farm.edit.creation': 'Create farm',
    'farm.edit.edition': 'Edit farm',
    'farm.edit.proprietaire': 'Owner',
    'farm.edit.nom': 'Name',
    'farm.edit.fms': 'FMS id',
    'farm.edit.adresse': 'Address',
    'farm.edit.adrComp': 'Additional address',
    'farm.edit.cp': 'Postcode',
    'farm.edit.ville': 'City',
    'farm.edit.pays': 'Country',
    'farm.edit.siret': 'Company identification system (optional)',
    'farm.edit.siret.placeholder': 'Company identification system',
    'farm.edit.idDistr': 'Organisation name (optional)',
    'farm.edit.idDistr.placeholder': 'Organisation name',
    'farm.edit.unauthorized': 'You are not authorized to edit this farm',
    'farm.edit.view.unauthorized': 'You are not authorized to view this farm',

    'parcel.section': 'Fields',
    'parcel.table.textTop':
      'On this page, you can create and draw your fields. Once these have been created, click on "Orders" in the menu to order advice (rapeseed, wheat, barley).',
    'parcel.table.filter.parcelle': 'field',
    'parcel.table.filter.exploitation': 'farm',
    'parcel.table.filter.id': 'id',
    'parcel.table.filter.conseiller': 'Advisor',
    'parcel.table.filter.conseiller.placeholder': 'advisor login',
    'parcel.table.filter.culture': 'Crop',
    'parcel.table.filter.campagne': 'Season',
    'parcel.table.filter.distributeur': 'Organisation',
    'parcel.table.filter.facturation': 'Billing',
    'parcel.table.filter.facturation.choice.facturer': 'billable',
    'parcel.table.filter.facturation.choice.nePasFacturer': 'not billable',
    'parcel.table.button.add': 'Create field',
    'parcel.table.parcelsBatch.tooltip':
      'These buttons allow you to perform the same action on ALL the filtered fields',
    'parcel.table.downloadKML': 'Download all KML files',
    'parcel.table.none': 'No field to display',
    'parcel.table.nom': 'Name',
    'parcel.table.exploitation': 'Farm',
    'parcel.table.culture': 'Crop',
    'parcel.table.surface': 'Area',
    'parcel.table.campagne': 'Season',
    'parcel.table.complete': 'Completed',
    'parcel.table.imgOK.alt': 'completed',
    'parcel.table.imgOK.title': 'Completed',
    'parcel.table.imgWarning.alt': 'not completed',
    'parcel.table.imgWarning.title': 'Mot completed',
    'parcel.table.button.reuse': 'Reuse',
    'parcel.table.button.reuse.tooltip': 'Reuse these contours to define a field for the current season',
    'parcel.table.button.edit': 'Edit the field',
    'parcel.table.button.delete': 'Delete the field permanently',

    'parcel.edit.creation': 'Create new field',
    'parcel.edit.edition': 'Edit field',
    'parcel.edit.campagne': 'Season',
    'parcel.edit.exploitation': 'Farm',
    'parcel.edit.exploitation.loading': 'Loading farms...',
    'parcel.edit.nom': 'Field name',
    'parcel.edit.nom.placeholder': 'Name',
    'parcel.edit.cp': 'Postcode',
    'parcel.edit.pays': 'Country',
    'parcel.edit.ville': 'City (optional)',
    'parcel.edit.ville.placeholder': 'City',
    'parcel.edit.pac': 'CAP plot number (optional)',
    'parcel.edit.pac.placeholder': 'CAP plot number',
    'parcel.edit.fms': 'FMS ID',
    'parcel.edit.idDistr': 'Organisation ID (optional)',
    'parcel.edit.idDistr.placeholder': 'Organisation ID',
    'parcel.edit.culture': 'Crop',
    'parcel.edit.culture.restricted': 'The crop cannot be modified because the parcel has an associated order.',
    'parcel.edit.destination': 'Aim',
    'parcel.edit.variete': 'Main variety',
    'parcel.edit.variete.cultureWarning': 'Select the crop first',
    'parcel.edit.variete.all': 'All',
    'parcel.edit.variete.autre': 'Other',
    'parcel.edit.variete.melange': 'Varieties Mix',
    'parcel.edit.precedent': 'Previous crop',
    'parcel.edit.precedent.placeholder': 'Previous crop',
    'parcel.edit.jachere': 'Fallow type',
    'parcel.edit.ageJachere': 'Fallow age',
    'parcel.edit.devenir': 'Crop residue management',
    'parcel.edit.devenir.placeholder': 'Crop residue management',
    'parcel.edit.sol': 'Soil',
    'parcel.edit.sol.cpWarning': 'Select the postcode and the country first',
    'parcel.edit.sol.cpError': 'Unrecognized postcode!',
    'parcel.edit.profondeur': 'Soil depth',
    'parcel.edit.profondeur.placeholder': 'Depth',
    'parcel.edit.dateSemis': 'Sowing date',
    'parcel.edit.noFacturation': 'No invoice',
    'parcel.edit.geometry.warning': "Don't forget to draw your field!",
    'parcel.edit.geometry.instructions.html':
      '<label><b>Please draw your field : </b></label><label>- find the geographical area using the magnifying glass</label><label>- click on the polygon icon on the map to start defining the outline</label><label>- double-click to confirm your outline</label>',
    'parcel.edit.geometry.import': 'Import a contour in KML format',
    'parcel.edit.importData': 'Import Field Data from Climate Fieldview',
    'parcel.edit.geometry.import.error': 'Unsupported KML file',
    'parcel.edit.geometry.surfaceError': 'Please note: Only fields larger than 1 ha can be ordered.',
    'parcel.edit.surface': 'Area',
    'parcel.edit.unauthorized': 'You are not authorized to edit this field',
    'parcel.edit.view.unauthorized': 'You are not authorized to view this field',
    'parcel.edit.error': 'There are errors in the form',
    'parcel.edit.map.showRPG': 'Display the RPG layer 2021', // ne devrait pas être affiché
    'parcel.edit.map.contour': 'Use this contour',
    'parcel.edit.map.searchAddress': 'Search an address',
    'parcel.edit.map.selectContour': 'Cliquer pour select a contour SUPPR', // ne devrait pas être afficher
    'parcel.edit.map.showAutresParcelles': 'Display the fields of the same farm',

    'parcel.dialog.title': 'Field details',
    'parcel.dialog.nom': 'Name',
    'parcel.dialog.pac': 'CAP plot #',
    'parcel.dialog.cp': 'Postcode',
    'parcel.dialog.ville': 'City',
    'parcel.dialog.pays': 'Country',
    'parcel.dialog.exploitation': 'Farm',
    'parcel.dialog.culture': 'Crop',
    'parcel.dialog.destination': 'Aim',
    'parcel.dialog.variete': 'Variety',
    'parcel.dialog.precedent': 'Previous crop',
    'parcel.dialog.jachere': 'Type de jachère',
    'parcel.dialog.ageJachere': 'Age de jachère',
    'parcel.dialog.devenir': 'Crop residue management',
    'parcel.dialog.sol': 'Soil',
    'parcel.dialog.profondeur': 'Soil depth',
    'parcel.dialog.dateSemis': 'Sowing date',
    'parcel.dialog.campagne': 'Season',
    'parcel.dialog.surface': 'Area',
    'parcel.dialog.import': 'Import',

    'parcel.delete.confirm.title': 'Confirm deletion',
    'parcel.delete.confirm.question': (
      parcelText: string,
    ) => `Do you confirm the deletion of the field ${parcelText}?<br>
    The deletion will also delete the information entered as part of the order.`,

    'map.dessin': 'Draw a field',
    'map.cancel': 'Cancel drawing',
    'map.cancel.short': 'Cancel',
    'map.terminer': 'Finish drawing',
    'map.supprDernierPoint': 'Remove last point',
    'map.clicCommencer': 'Click to start drawing',
    'map.clicPoursuivre': 'Click to continue drawing',
    'map.clicPremierPoint': 'Click on first point to close the polygon',
    'map.sauver': 'Save',
    'map.suppr': 'Delete',
    'map.modifier': 'Edit contour',
    'map.noParcelle': 'No contour to edit',
    'map.clicPointsMove': 'Click on the points to move them',
    'map.clicCancel': 'Click on cancel to undo changes',
    'map.supprParcelle': 'Delete contour',
    'map.noParcelleSuppr': 'No contour to delete',
    'map.clicParcelleSuppr': 'Click on the contour to delete it',
    'map.intersection': 'Self-intersections are forbidden!',
    'map.zoomIn': 'Zoom in',
    'map.zoomOut': 'Zoom out',

    'fieldview.button.connect': 'Link your account to FieldView',
    'fieldview.connect.wait': 'Connecting to FieldView...',
    'fieldview.connect.success': 'Your account was succesfully linked to FieldView.',
    'fieldview.connect.error': 'Error during connection to FieldView. Please contact customer support.',
    'fieldview.button.disconnect': 'Unlink your account from FieldView',
    'fieldview.disconnect.success': 'Your account was succesfully unlinked from FieldView.',
    'fieldview.disconnect.error': 'Error unlinking your account from FieldView. Please contact customer support.',

    'fieldview.table.name': 'Name',
    'fieldview.table.id': 'Id',
    'fieldview.table.import': 'Import',
    'fieldview.dialog.title': 'FieldView Parcels',

    'orders.title': 'Orders',
    'orders.view': 'View',
    'orders.arcolza': 'Nitrogen fertilisation<br>RAPESEED',
    'orders.arcolza.imgAlt': 'Colza',
    'orders.arble': 'Nitrogen fertilisation<br>WHEAT',
    'orders.arble.imgAlt': 'Wheat',
    'orders.arorge': 'Nitrogen fertilisation BARLEY<br><small><small><small>And other species modulation *',
    'orders.arorge.imgAlt': 'Barley',
    'orders.arorge.asterisk': '* : Rye, Triticale, Hemp, Meadow, Maize, Potato, Flax',
    'orders.zsn': 'SOWING',
    'orders.zsn.imgAlt': 'Sowing',

    'ar.button.sauverCommander': 'Save and order',

    'ar.colza.section': 'Nitrogen fertilisation Rapeseed',
    'ar.colza.table.eligible':
      'The fields below are eligible for the rapeseed nitrogen fertilisation advice. You must fill in the information for the advice, then you have to order it.',
    'ar.colza.table.filter.destination': 'Aim',

    'ar.colza.error.suppr': 'Error deleting rapeseed fertilisation information',
    'ar.colza.error.varietes': 'Error fetching list of varieties',

    'ar.colza.edit.title.uneParcelle': 'Rapeseed fertilisation information - Field',
    'ar.colza.edit.title.multiParcelles': 'Rapeseed fertilisation information for selected fields',
    'ar.colza.edit.conseil': 'What type of advice would you like?',
    'ar.colza.edit.conseil.choice.zonage': 'With intra-parcel zoning',
    'ar.colza.edit.conseil.choice.simplifie': 'simplified - Without intra-parcel zoning',
    'ar.colza.edit.couvert': 'Is the rapeseed combined with a cover of leguminous plants ?',
    'ar.colza.edit.couvert.tooltip': 'In this case, it is impossible to measure the biomass at the start of winter.',
    'ar.colza.edit.couvert.header': 'Cover ?',
    'ar.colza.edit.objectif': 'Target yield (q/ha)',
    'ar.colza.edit.objectif.placeholder': 'Target',
    'ar.colza.edit.apportmo': 'Input of organic matter',
    'ar.colza.edit.apportmo.hist': 'History of organic matter inputs',
    'ar.colza.edit.apportmo.hist.freq': 'Input frequency',
    'ar.colza.edit.apportmo.hist.freq.header': 'Frequency',
    'ar.colza.edit.apportmo.hist.produit': 'Product generally supplied',
    'ar.colza.edit.apportmo.hist.produit.header': 'Product',
    'ar.colza.edit.apportmo.automne': 'Organic products applied in autumn',
    'ar.colza.edit.apportmo.automne.1': '1st Input',
    'ar.colza.edit.apportmo.automne.2': '2nd Input',
    'ar.colza.edit.apportmo.automne.produit': 'Product',
    // TODO voir conversion unités
    'ar.colza.edit.apportmo.automne.teneur': 'Nitrogen content (kgN/t)',
    'ar.colza.edit.apportmo.automne.1.teneur.placeholder': 'Content (1st input)',
    'ar.colza.edit.apportmo.automne.2.teneur.placeholder': 'Content (2nd input)',
    'ar.colza.edit.apportmo.automne.quantite': 'Quantity of product spread (t/ha)',
    'ar.colza.edit.apportmo.automne.1.quantite.placeholder': 'Quantity of product spread (1st input)',
    'ar.colza.edit.apportmo.automne.2.quantite.placeholder': 'Quantity of product spread (2nd input)',
    'ar.colza.edit.reliquat': 'Do you have a winter residue measurement?',
    'ar.colza.edit.reliquat.header': 'Residue?',
    'ar.colza.edit.reliquat.mesure': 'Residue measurement (nitrogen kgN)',
    'ar.colza.edit.reliquat.mesure.placeholder': 'Residue measurement',
    'ar.colza.edit.apport1SH': "First mineral fertilisation at winter's (optional)",
    // TODO revoir traduction
    'ar.colza.edit.apport1SH.tooltip':
      "Fill this information if you intend to apply fertiliser before winter's end and you want it to be variable rate.",
    'ar.colza.edit.apport1SH.dose.1': 'Dose (nitrogen kgN)',
    'ar.colza.edit.apport1SH.dose.2': "(This dose will be deducted from the total dose computed at winter's end)",
    'ar.colza.edit.apport1SH.dose.placeholder': 'Nitrogen dose',
    'ar.colza.edit.apport1SH.engraisMineralPrevu': 'Planned mineral nitrogen fertiliser',
    'ar.colza.edit.dernierApportSH': "Final input at winter's end",
    'ar.colza.edit.dernierApportSH.engraisMineralPrevu': 'Planned mineral nitrogen fertiliser',
    'ar.colza.edit.carteepandage.choix':
      'For your 1st input, would you like to receive a modulation map based on biomass measured at the start of winter?',
    'ar.colza.edit.information.planning':
      'Please consult the "Planning" menu to check the planned restitution period and modify it if necessary. An order modification does not modify the recorded restitution date.',

    'ar.ble.section': 'Nitrogen fertilisation Wheat',
    // identique au colza + orge pour l'essentiel
    // TODO en commun ?
    'ar.ble.table.eligible':
      'The fields below are eligible for the wheat nitrogen fertilisation advice. You must fill in the information for the advice, then you have to order it.',
    'ar.ble.table.filter.culture': 'Crop',
    'ar.ble.table.t1': 'Tillering (BBCH 21-29)',
    'ar.ble.table.t2': 'First node at 1cm (BBCH 30-31)',
    'ar.ble.table.verse': 'Lodging',
    'ar.ble.table.2n': 'Second node (BBCH 32)',
    // TODO voir
    'ar.ble.table.t3': 'Flag leaf fully emerged (BBCH 39)',

    'ar.ble.error.suppr': 'Error deleting wheat fertilisation information',
    'ar.ble.error.cultures': 'Error fetching list of crops',

    'ar.ble.edit.title.uneParcelle': 'Wheat fertilisation information - Field',
    'ar.ble.edit.title.multiParcelles': 'Wheat fertilisation information for selected fields',
    'ar.ble.edit.contactSupport': 'If you encounter errors, please contact Customer Support.',
    'ar.ble.edit.conseil': 'What type of advice would you like?',
    'ar.ble.edit.warning.existing':
      'A file has already been generated for this field: You cannot change the type of advice.',
    'ar.ble.edit.4passages':
      '4 advices (Tillering (BBCH 21-29), First node at 1cm (BBCH 30-31), management at Second node (BBCH 32) and at Flag leaf fully emerged (BBCH 39))',
    // TODO revoir
    'ar.ble.edit.stade.choice.2n': 'Second node (BBCH 32)',
    'ar.ble.edit.stade.choice.3n': 'Third node',
    'ar.ble.edit.stade.choice.dfe': 'Flag leaf fully emerged (BBCH 39)',
    'ar.ble.edit.4passages.warning': 'The pricing for the last 2 are independant of the previous stages.',
    'ar.ble.edit.bleTallage.warning': "The orders for 'Tillering (BBCH 21-29)' are closed",
    'ar.ble.edit.3passages':
      '3 advices (Tillering (BBCH 21-29), First node at 1cm (BBCH 30-31) and management at Flag leaf fully emerged (BBCH 39))',
    'ar.ble.edit.2passages':
      '2 advices (First node at 1cm (BBCH 30-31) and management at Flag leaf fully emerged (BBCH 39))',
    'ar.ble.edit.bleDebutMontaison.warning': "The orders for 'First node at 1cm (BBCH 30-31)' are closed",
    'ar.ble.edit.1passage': '1 advice (management at Flag leaf fully emerged (BBCH 39))',
    'ar.ble.edit.bleFinMontaison.warning': "The orders at 'Flag leaf fully emerged (BBCH 39)' are closed",
    'ar.ble.edit.zonage': 'Would you like your intra-parcel zoning?',
    'ar.ble.edit.zonage.tooltip':
      'Advice without  intra-parcel zoning is only available with the 1-advice offer (Last application at Flag leaf fully emerged (BBCH 39)). With this simplified offer, it is not possible to request a console file at a later date.',
    'ar.ble.edit.zonage.non':
      'No - no intra-parcel zoning - simplified advice (CAUTION only possible with 1-advice offer)',
    'ar.ble.edit.zonage.oui.mobile': 'Yes - available on the mobile application and PDF reports (maximum of 3 zones)',
    'ar.ble.edit.zonage.oui.manual': 'Yes - manual console version - guide bar type (maximum 3 zones)',
    'ar.ble.edit.zonage.oui.auto': 'Yes - automatic console version (maximum 6 zones )',
    'ar.ble.edit.zonage.warning':
      'Please note: this simplified offer does not include zoning or intra-parcel modulation (average dose only).',

    'ar.ble.edit.engrais': 'Planned mineral nitrogen fertiliser',
    'ar.ble.edit.engrais.dose.placeholder': 'Nitrogen dose',

    'ar.ble.edit.tallage': 'Tillering (BBCH 21-29) input',
    'ar.ble.edit.tallage.dose': 'Dose to be applied at Tillering (BBCH 21-29) (nitrogen kgN)',
    // TODO revoir split? fractionnement?
    'ar.ble.edit.tallage.dose.tooltip':
      'Indicate the amount of nitrogen you plan to apply at the tillering (BBCH 21-29) according to your split.',

    'ar.ble.edit.debutMontaison': 'First node at 1 cm input',
    'ar.ble.edit.debutMontaison.dose': 'Dose to be applied at first node at 1 cm (nitrogen kgN)',
    'ar.ble.edit.debutMontaison.dose.tooltip':
      'Indicate the amount of nitrogen you plan to apply at the first node at 1 cm according to your split.',
    'ar.ble.edit.debutMontaison.verse': 'Risk of lodging',

    'ar.ble.edit.2n': 'Managed input at Second node (BBCH 32)',

    'ar.ble.edit.2n.infoText.html': `You must fill the following information:

    <ul>
    <li>The type and concentration of nitrogen fertiliser you intend to apply</li>
    <li>The brand and version of the console used for VRA (if requested)</li>
    </ul>

    If nof filled for now, those informations will be requested at the time the report is generated.`,
    'ar.ble.edit.2n.noInfo': 'No additional information is needed for the advice at Second node (BBCH 32)',

    'ar.ble.edit.3nDfe': 'Managed input at Flag leaf fully emerged (BBCH 39)',
    'ar.ble.edit.3nDfe.infoText.html': `You must fill the following information:

    <ul>
      <li>The type and concentration of nitrogen fertiliser you intend to apply</li>
      <li>The brand and version of the console used for VRA (if requested)</li>
    </ul>

    If nof filled for now, those informations will be requested at the time the report is generated.`,
    'ar.ble.edit.3nDfe.noInfo':
      'No additional information is needed for the advice at Flag leaf fully emerged (BBCH 39)',
    'ar.ble.edit.3nDfe.info': 'Optional information',
    'ar.ble.edit.3nDfe.dose.pre':
      'Doses already applied (all inputs combined) before the planned application at Flag leaf fully emerged (BBCH 39) (nitrogen kgN)',
    'ar.ble.edit.3nDfe.dose.dernier': 'Including a final input of (nitrogen kgN)',
    'ar.ble.edit.3nDfe.dose.dernier.placeholder': 'Last nitrogen dose',
    'ar.ble.edit.3nDfe.dose.dernier.date': 'Made on (date of last input)',
    'ar.ble.edit.dose.dernier.date.noDate': 'No information',
    'ar.ble.edit.information.t1':
      'If your crop is showing signs of nutritional stress, a dose of 40 units is sufficient for spring growth restart. As a reminder, nitrogen does not promote tillering, and excess nitrogen at the tillering stage is detrimental to economic performance.',
    'ar.ble.edit.information.t2':
      'The application at the start of stem elongation is the main one, accounting for 60% to 80% of the total input. For maximum efficiency, it is advisable not to exceed 40 to 60 nitrogen units per application. ' +
      'Above this amount, it is preferable to split the application. Applying more than 100 units at once is strictly prohibited in Nitrate Vulnerable Zones.',
    'ar.ble.edit.information.planning':
      'Please consult the "Planning" menu to check the planned restitution period and modify it if necessary. An order modification does not modify the recorded restitution date.',

    'ar.ble.edit.objectif': 'Target yield (q/ha)',
    'ar.ble.edit.objectif.placeholder': 'Target',
    'ar.ble.edit.objectif.tooltip': 'Select the yields mean on the last 5 years in similar soil conditions.',

    'ar.ble.edit.doseppf': 'Projected dose',
    'ar.ble.edit.doseppf.placeholder': 'Projected dose',
    'ar.ble.edit.doseppf.tooltip': 'Projected dose (optional)',

    'ar.ppf.conseil': 'Along with your advice, would you like to estimate fertilization plans ?',
    'ar.ppf.conseil.warning': 'Warning : these plans are only informative.',

    'ar.orge.section': 'Nitrogen fertilisation Barley',
    'ar.orge.table.eligible':
      'The fields below are eligible for the barley nitrogen fertilisation advice, or for other species modulation. You must fill in the information for the advice, then you have to order it.',
    'ar.orge.table.filter.culture': 'Crop',
    'ar.orge.table.ppf': 'Manure estimated plan',
    'ar.orge.table.t1': 'Tillering',
    'ar.orge.table.t2': 'Beginning of stem elongation',
    'ar.orge.table.t3': 'End of stem elongation',

    'ar.orge.error.suppr': 'Error deleting barley fertilisation information',
    'ar.orge.error.cultures': 'Error fetching list of crops',

    'ar.orge.edit.title.uneParcelle': 'Specy fertilisation information - Field',
    'ar.orge.edit.title.multiParcelles': 'Fertilisation information for selected fields',
    'ar.orge.edit.contactSupport': 'If you encounter errors, please contact Customer Support.',
    'ar.orge.edit.conseil': 'What type of advice would you like ?',
    'ar.orge.edit.3passages':
      '3 advices (Barley: tillering, beginning of stem elongation and end of stem elongation)',
    'ar.orge.edit.3passages.warning': "The orders for 'Tillering' are closed",
    'ar.orge.edit.2passages': '2 advices (Barley : beginning and ending of stem elongation)',
    'ar.orge.edit.2passages.warning': "The orders for 'Beginning of stem elongation' are closed",
    'ar.orge.edit.1passage': '1 advice (Barley : ending of stem elongation)',
    'ar.orge.edit.1passage.warning': "The orders for 'End of stem elongation' are closed",
    'ar.orge.admin.orderT1EndingOn': 'T1 order closing date:',
    'ar.orge.admin.dataT1EndingOn': 'T1 data-entry closing date:',
    'ar.orge.admin.notProvided': 'Not provided',
    'ar.orge.edit.tallage': 'Tillering (BBCH 21-29) input',
    'ar.orge.edit.tallage.dose': 'Dose to be applied at tillering (BBCH 21-29) (nitrogen kgN)',
    'ar.orge.edit.tallage.dose.tooltip':
      'Indicate the amount of nitrogen you plan to apply at tillering (BBCH 21-29) according to your split.',
    'ar.orge.edit.information.t1':
      'If your crop is showing signs of nutritional stress, a dose of 40 units is sufficient for spring growth restart. As a reminder, nitrogen does not promote tillering, and excess nitrogen at the tillering stage is detrimental to economic performance.',
    'ar.orge.edit.debutMontaison': 'Beginning of stem elongation input (Barley)',
    'ar.orge.edit.debutMontaison.dose':
      'Dose to be applied at beginning of stem elongation (nitrogen kgN)',
    'ar.orge.edit.finMontaison': 'End of stem elongation input (Barley)',
    'ar.orge.edit.finMontaison.dose': 'Dose to be applied at end of stem elongation (nitrogen kgN)',
    'ar.orge.edit.engrais': 'Planned mineral nitrogen fertiliser',
    'ar.orge.edit.engrais.dose.placeholder': 'Nitrogen dose',
    'ar.orge.edit.pilotage': "For your 'Ending of stem elongation' advice, would you like nitrogen dose management?",
    // memes textes que pour le ble
    'ar.orge.edit.zonage': 'Would you like your intra-parcel zoning?',
    'ar.orge.edit.zonage.non':
      'No - no intra-parcel zoning - simplified advice (CAUTION only possible with 1-advice offer)',
    'ar.orge.edit.zonage.oui.mobile': 'Yes - available on the mobile application and PDF reports (maximum of 3 zones)',
    'ar.orge.edit.zonage.oui.manual': 'Yes - manual console version - guide bar type (maximum 3 zones)',
    'ar.orge.edit.zonage.oui.auto': 'Yes - automatic console version (maximum 6 zones )',
    'ar.orge.edit.zonage.warning':
      'Please note: this simplified offer does not include zoning or intra-parcel modulation (average dose only).',
    'ar.orge.edit.information.planning':
      'Please consult the "Planning" menu to check the planned restitution period and modify it if necessary. An order modification does not modify the recorded restitution date.',

    'ar.table.filter.parcelle.placeholder': 'field',
    'ar.table.filter.exploitation.placeholder': 'farm',
    'ar.table.filter.id.placeholder': 'id',
    'ar.table.filter.conseiller.placeholder': 'advisor login',
    'ar.table.filter.campagne': 'Season',
    'ar.table.filter.distr': 'Organisation',
    'ar.table.filter.parcellesCompletes': 'Completed fields',
    'ar.table.filter.parcellesCompletes.choice.complete': 'Completed',
    'ar.table.filter.parcellesCompletes.choice.incomplete': 'Not completed',
    'ar.table.filter.commande': 'Order status',
    'ar.table.filter.commande.choice.commande': 'Ordered',
    'ar.table.filter.commande.choice.nonCommande': 'Not ordered',

    'ar.table.recap': 'See the recap of orders placed',
    'ar.table.button.infoFill': 'Fill in / update data for the advice',
    'ar.table.button.removeOrder': 'Remove order',
    'ar.table.ordersBatch.tooltip':
      'These buttons allow you to perform the same action on ALL the selected fields (ticked box)',

    'ar.table.nom': 'Name',
    'ar.table.exploitation': 'Farm',
    'ar.table.surface': 'Area',
    'ar.table.commande': 'Order status',
    'ar.table.commande.eh': 'Early winter',
    'ar.table.commande.sh': 'Late winter',
    'ar.table.ref': 'Reference',
    'ar.table.beapi': 'BeApi',

    'ar.table.commande.complete.title': 'advice ordered and data completed',
    'ar.table.commande.complete.alt': 'completed',
    'ar.table.commande.incomplet.title': 'advice ordered but data incomplete',
    'ar.table.commande.incomplet.alt': 'not completed',
    'ar.table.commande.nc.text': 'TBD',
    'ar.table.commande.beapi.commande.title': 'BeApi ordered',
    'ar.table.commande.beapi.commande.alt': 'ordered',

    'ar.table.error.recupParcellesDispo': 'Error fetching the number of available fields',
    'ar.table.error.unauthorized': 'You are not authorized to perform this operation',
    'ar.table.error.selection': 'Error selecting all the fields',

    'ar.edit.editionLot': 'Batch editing',
    'ar.edit.info.caseCochee':
      'When the checkbox next to the field is checked, the data will be set for all selected fields',
    'ar.edit.beapi': 'BeAPI ordered (not editable)',
    'ar.edit.choice.oui': 'Yes',
    'ar.edit.choice.non': 'No',
    'ar.edit.console': 'Console file',
    'ar.edit.console.tooltip':
      'If you are equipped with automatic modulation equipment, you will be supplied with a card in IT format to insert into your console. Please complete the fields below. These maps can also be read on a guidance console. The maps for automatic modulation are generated in 6 zones. Manual modulation maps are generated in 3 zones.',
    'ar.edit.error.pasDeParcelle': 'Field ID missing for page',
    'ar.edit.error.invalidNumber': 'There are invalid numbers in the form',
    'ar.edit.error.internal': 'There was an internal error',
    'ar.edit.error.unauthorized.edit': 'You are not authorized to edit this field',
    'ar.edit.error.unauthorized.edit.multiParcels': 'You are not authorized to edit these fields',
    'ar.edit.error.unauthorized.view': 'You are not authorized to view this field',
    'ar.edit.error.save.multiParcels': 'Error saving data for the selected fields',

    'ar.edit.ferti.forme': 'Type of fertiliser',
    'ar.edit.ferti.concentration': 'Concentration (%N)',
    'ar.edit.ferti.concentration.placeholder': 'Concentration',

    'ar.edit.vra.infoMobile':
      'You have chosen to get a modulation map, you will find it automatically on the mobile application.',
    'ar.edit.vra.console': 'Would you also like a file to be inserted into your console for this field?',
    'ar.edit.vra.console.header': 'VRA file?',
    'ar.edit.vra.console.marque': 'Console brand',
    'ar.edit.vra.console.marque.other': 'Other brand',
    'ar.edit.vra.console.marque.header': 'Console',
    'ar.edit.vra.console.version': 'Console version',
    'ar.edit.vra.console.version.warning': 'Enter the brand name first',
    'ar.edit.vra.console.version.header': 'Version',
    'ar.edit.vra.console.version.other': 'Other version',
    'ar.edit.vra.console.version.free': 'Specify console version',
    'ar.edit.vra.console.version.free.placeholder': 'Console version',
    'ar.edit.vra.console.format': 'Format',
    'ar.edit.vra.console.format.nonConnu': 'Unknown format',
    'ar.edit.vra.console.format.warning': 'Enter the brand and the version first',

    'ar.edit.verse.choix': 'Would you like a lodging risk assessment?',
    'ar.edit.verse.choix.title': 'Lodging risk assessment?',
    'ar.edit.verse.apportMO': 'Input of organic matter',
    'ar.edit.verse.apportMO.tooltip':
      'If an organic product is applied to the crop in late summer or autumn, either before sowing or during vegetation, indicate the type of product applied. Given the wide variability in the average composition of products and spreading practices, it is advisable to use measured values. If no analyses are available, default values will be used.',
    'ar.edit.verse.apport.mo.automne': 'Organic fertilisers applied in autumn',
    'ar.edit.verse.apport.mo.automne.choix': 'Number of applications',
    'ar.edit.verse.frequence': 'Input frequency',
    'ar.edit.verse.frequence.choix': 'Frequency',
    'ar.edit.verse.apports.mineraux': 'Mineral fertilisers',
    'ar.edit.verse.apports.mineraux.fractionnement': 'Split of mineral fertilisers',
    'ar.edit.verse.apports.mineraux.fractionnement.choix': 'Split',
    // FIXME supprimer les textes plus utilisés
    'ar.edit.verse.apportMo.1': '1st input',
    'ar.edit.verse.produit': 'Product',
    'ar.edit.verse.periode': 'Input period',
    'ar.edit.verse.periode.title': 'Period',
    'ar.edit.verse.teneur': 'Nitrogen content (kgN/t or kgN/m³)',
    'ar.edit.verse.apportMo.1.teneur.placeholder': 'Content (1st input)',
    'ar.edit.verse.quantite': 'Quantity of product spread (t/ha or m³/ha)',
    'ar.edit.verse.apportMo.1.quantite.placeholder': 'Quantity of product (1st input)',
    'ar.edit.verse.apportMo.2': '2nd input',
    'ar.edit.verse.apportMo.2.teneur.placeholder': 'Content (2nd input)',
    'ar.edit.verse.apportMo.2.quantite.placeholder': 'Quantity of product (2nd input)',
    'ar.edit.verse.historique': 'History of organic matter inputs',
    'ar.edit.verse.historique.tooltip': 'This is the history of organic inputs to the field over the last few years.',

    'ar.edit.verse.historique.produit': 'Product generally supplied',
    'ar.edit.verse.historique.produit.tooltip':
      'If several types of product are supplied, give preference to slow-decomposing products such as manures and composts.',
    'ar.edit.verse.historique.produit.choix': 'Product',

    'ar.colza.gc.choix': 'Choice of the advice',
    'ar.colza.gc.choix.colzaeh': '1st input based on biomass measured at the start of winter',
    'ar.colza.gc.choix.colzash': 'Last input based on biomass measured at the end of winter',

    'ar.ble.gc.choix': 'Choice of the advice',
    'ar.ble.gc.choix.t1': 'Tillering (BBCH 21-29)',
    'ar.ble.gc.choix.t2': 'First node at 1cm (BBCH 30-31)',
    'ar.ble.gc.choix.2n': 'Second node (BBCH 32)',
    'ar.ble.gc.choix.t3': 'Flag leaf fully emerged (BBCH 39)',

    'ar.orge.gc.choix': 'Choice of the advice',
    'ar.orge.gc.choix.t2': 'Beginning of stem elongation',
    'ar.orge.gc.choix.t3': 'End of stem elongation',

    'ar.gc.title': 'Generation of VRA files',
    'ar.gc.button.next': 'Next step',
    'ar.gc.button.back': 'Back',
    'ar.gc.button.validate': 'Validate',
    'ar.gc.button.gen': 'Generate files',
    'ar.gc.error.sauverDoses': 'Error saving doses',
    'ar.gc.error.sauverConsoles': 'Error saving console information',
    'ar.gc.genSuccess': 'Files have been generated successfully!',
    'ar.gc.error.genError': 'Error generating the VRA files! Please contact customer support',
    'ar.gc.error.unauthorized': 'You are not authorized to update this info',
    'ar.gc.error.recupDoses': 'Error fetching doses',
    'ar.gc.noParcelles': 'No field to display',

    'ar.gc.fd.title': 'Choice of dose for VRA file',
    'ar.gc.fd.parcelle': 'Field',
    'ar.gc.fd.dosePreco': 'Recommended dose',
    'ar.gc.fd.doseConsole': 'Dose for VRA file',

    'ar.gc.gp.title': 'Optional - Merging fields',
    'ar.gc.gp.subtitle': 'Merge several files into one for contiguous fields',
    'ar.gc.gp.solid': 'Solid',
    'ar.gc.gp.liquid': 'Liquid',
    'ar.gc.gp.warning.rds':
      'RDS files cannot be generated through this form. Please contact customer support to obtain VRA files in RDS format.',
    'ar.gc.gp.warning.teejetChallenger':
      'Files for Teejet, Challenger, Valtra and Massey Ferguson consoles cannot be generated via this interface. Contact customer support to obtain a file for these consoles.',
    'ar.gc.gp.warning.amatron4':
      'Files for Amatron 4 cannot  be generated through this form. Please contact customer support to obtain VRA files for that console.',
    'ar.gc.gp.warning.fertilizer': 'missing',
    'ar.gc.gp.parcelle': 'Field',
    'ar.gc.gp.groupe': 'Group',
    'ar.gc.gp.noGroupe': 'No groupe',
    'ar.gc.gp.noFusion': 'No merge possible',
    'ar.gc.gp.groupe.base': 'Group',

    'ar.gc.launcher.title': 'Launch VRA file generation',
    'ar.gc.launcher.text.1':
      "Click on 'Generate files' to start generating the VRA files. This stage may take several minutes.",
    'ar.gc.launcher.text.2': 'Please do not close the browser window until the treatment is complete!',
    'ar.gc.launcher.text.3.p1': 'The files generated will be available on',
    'ar.gc.launcher.text.3.p2': 'advices',

    'ar.gc.sc.dialog.title': 'Console and fertiliser for this field',
    'ar.gc.sc.dialog.console': 'VRA file',
    'ar.gc.sc.dialog.engrais': 'Nitrogen mineral fertiliser input',

    'ar.gc.sc.title': 'Check consoles and fertiliser types',
    'ar.gc.sc.error.consoles': 'Error checking console information!',
    'ar.gc.sc.unknown': 'Unknown',
    'ar.gc.sc.other.marque': 'Other brand',
    'ar.gc.sc.other.version': 'Other version',
    'ar.gc.sc.parcelle': 'Field',
    'ar.gc.sc.console': 'Console',
    'ar.gc.sc.engrais': 'Fertiliser',
    'ar.gc.sc.button.modiferSelection': 'Edit selected',

    'ar.gc.sf.title': 'Choice of farms',
    'ar.gc.sf.noParcelles': 'No field available for VRA file generation!',
    'ar.gc.sf.error.exploitations': 'Error fetching farms',
    'ar.gc.sf.warning':
      'The farms displayed are only those for which advice is available and for which a console has been entered in the order.',
    'ar.gc.sf.filter.exploitation.placeholder': 'farm name',
    'ar.gc.sf.filter.distributeur': 'Organisation',
    'ar.gc.sf.noExploitations': 'No farm to display',
    'ar.gc.sf.nom': 'Name',
    'ar.gc.sf.ville': 'City',

    'ar.order.section': 'Orders',
    'ar.order.table.filter.exploitations': 'Filter by farm',
    'ar.order.table.filter.campagne': 'Filter by season',
    'ar.order.table.filter.campagne.base': 'Season',
    'ar.order.table.filter.distributeur': 'Organisation',
    'ar.order.table.distributeur': 'Organisation',
    'ar.order.table.date': 'Date',
    'ar.order.table.numParcelles': 'Number of fields',
    'ar.order.table.utilisateurs': 'Users',
    'ar.order.table.exploitations': 'Farms',
    'ar.order.table.edit': (specyString: string) => 'Edit this ' + specyString + ' nitrogen fertilisation order',
    'ar.order.table.delete': (specyString: string) =>
      'Permanently delete this ' + specyString + ' nitrogen fertilisation order',
    'ar.order.table.view': (specyString: string) => 'Voir cette commande de conseil ' + specyString,
    'ar.order.error.load': 'Impossible de récupérer les commandes',
    'ar.order.delete.confirm': 'Etes-vous certain de bien vouloir supprimer définitivement cette commande ?',
    'ar.order.error.delete': (specyString: string) =>
      'View this ' + specyString + ' nitrogen fertilisation advice order',
    'ar.order.error.unauthorized': 'You are not authorized to view this order',

    'ar.order.total': 'Total ordered',
    'ar.order.total.space': '      ',
    // TODO remplacer les 2 par function prenant le num de parcelles en arg
    'ar.order.total.parcelles': 'Fields',
    'ar.order.total.parcelles.number': 'fields',
    'ar.order.total.surface': 'Area',

    'ar.order.edit.edition': 'Edit order',
    'ar.order.edit.view': 'Order details',
    'ar.order.edit.creation': 'Create order',
    'ar.order.edit.nom': 'Name',
    'ar.order.edit.ville': 'City',
    'ar.order.edit.surface': 'Area',
    'ar.order.edit.button.delete.tooltip': 'Remove this field from the order',
    'ar.order.edit.button.back': 'Back',
    'ar.order.edit.button.confirm': 'Confirm the order',
    'ar.order.edit.prompt.delete': 'This order no longer has any fields. Do you want to delete it?',
    'ar.order.edit.prompt.confirmation':
      "Your order has been saved. Please fill the requested delivery dates in the 'Planning' menu.",
    'ar.order.edit.error.load': 'Error loading order',
    'ar.order.edit.wait': 'Please wait...',
    'ar.order.edit.error.hasOrder':
      'Some of the fields have already been ordered: Please unselect them before ordering\n',
    'ar.order.edit.error.orderItem':
      'Some of the fields cannot be ordered; Please fill the information before ordering\n',
    'ar.order.edit.error.loadInfoParcelles': (specyString: string) =>
      `Unable to load the ${specyString} information for the selected fields`,
    'ar.order.edit.delete.confirm': 'Are you sure to remove permanently this field from the order?',
    'ar.order.edit.unauthorized': 'You are not authorized to edit this order',
    'ar.order.edit.unauthorized.view': 'You are not authorized to view this order',

    'ar.result.dialog.title': 'Send advice by email',
    'ar.result.dialog.confirm': 'Do you confirm the selected file will be sent by email?',
    'ar.result.dialog.confirm.plural': 'Do you confirm that selected files will be sent by email?',
    'ar.result.dialog.confirm.destinataire': 'Recipient of files',
    'ar.result.dialog.confirm.destinataire.plural': 'Recipients of files',
    'ar.result.dialog.confirm.destinataire.agri': 'Farmers',
    'ar.result.dialog.confirm.destinataire.conseiller': 'Advisors',
    'ar.result.dialog.confirm.destinataire.respDistr': 'Organisation managers',

    'ar.result.table.filter.parcelle.placeholder': 'field',
    'ar.result.table.filter.exploitation.placeholder': 'farm',
    'ar.result.table.filter.id.placeholder': 'id',
    'ar.result.table.filter.conseiller.placeholder': 'advisor login',
    'ar.result.table.filter.type': 'Type of files',
    'ar.result.table.filter.campagne': 'Season',
    'ar.result.table.filter.distributeur': 'Organisation',
    'ar.result.table.filter.validation': 'Validation',
    'ar.result.table.filter.validation.choice.valide': 'Validated',
    'ar.result.table.filter.validation.choice.nonValide': 'Not validated',
    'ar.result.table.filter.visibilite': 'Visibility',
    'ar.result.table.filter.visibilite.choice.visible': 'Visible by users',
    'ar.result.table.filter.visibilite.choice.nonVisible': 'Not visible',
    'ar.result.table.filter.envoi.conseillers': 'Send to advisors',
    'ar.result.table.filter.envoi.agri': 'Send',
    'ar.result.table.filter.envoi.agri.wanaka': 'Send to farmers',
    'ar.result.table.filter.envoi.choice.envoye': 'Sent',
    'ar.result.table.filter.envoi.choice.nonEnvoye': 'Not sent',
    'ar.result.table.button.telecharger': 'Download',
    'ar.result.table.button.valider': 'Validate',
    'ar.result.table.button.disponible': 'Make available',
    'ar.result.table.button.envoyer': 'Send by email',
    'ar.result.table.tooltip.batch': 'These buttons allow you to perform the same action on ALL the selected files.',
    'ar.result.table.button.genConsole': 'Update a VRA file',
    'ar.result.table.tooltip.genConsole': 'Click on this button to generate a console file (with or without splitting)',
    'ar.result.table.date': 'Date',
    'ar.result.table.nom': 'Name',
    'ar.result.table.exploitation': 'Farm',
    'ar.result.table.conseil': 'Advice',
    'ar.result.table.valide': 'Validated',
    'ar.result.table.disponible': 'Available',
    'ar.result.table.admin': 'Admin',
    'ar.result.table.envoye': 'Sent',
    'ar.result.table.suppr.column': 'Delete',
    'ar.result.table.telecharger.column': 'Download',
    'ar.result.table.button.valider.row': 'Validate',
    'ar.result.table.button.invalider': 'Invalidate',
    'ar.result.table.button.public': 'Publish',
    'ar.result.table.button.cacher': 'Hide',
    'ar.result.table.button.envoyer.row': 'Send',
    'ar.result.table.button.invaliderEnvoi': 'Invalidate delivery',
    'ar.result.table.button.suppr': 'Delete',
    'ar.result.table.button.telecharger.row': 'Download',
    // le HTML est passé depuis JS donc pas besoin de safe
    'ar.result.table.warning.notSent':
      '- Check that the selected files have not already been sent<br/> - Check that the selected files have been validated',
    'ar.result.table.error.invalider': 'Error invalidating the file',
    'ar.result.table.error.valider': 'Error validating the file',
    'ar.result.table.error.cacher': 'Error hiding the file',
    'ar.result.table.error.public': 'Error publishing the file',
    'ar.result.table.confirm.invaliderEnvoi': 'Do you confirm the delivery of the selected file will be invalidated?',
    'ar.result.table.error.invaliderEnvoi': 'Error invalidating the delivery of the file',
    'ar.result.table.confirm.invaliderEnvoi.conseillers':
      'Do you confirm the delivery of the selected file to advisors will be invalidated?',
    'ar.result.table.error.invaliderEnvoi.conseillers': 'Error invalidating the delivery of the file to advisors',
    'ar.result.table.confirm.suppr': 'Do you confirm the selected file will be deleted?',
    'ar.result.table.error.suppr': 'Error deleting the file',
    'ar.result.table.error.telecharger': 'Error downloading the file',
    'ar.result.table.confirm.disponible': 'Do you confirm that selected files will be published?',
    'ar.result.table.error.disponible': 'Error publishing the file',
    'ar.result.table.confirm.valider': 'Do you confirm that selected files will be validated?',
    'ar.result.table.error.valider.plural': 'Error validating the files',
    'ar.result.table.error.envoi': 'Error sending the file to advisotrs',
    'ar.result.table.warning.envoi': (numResultsFound: number) =>
      'Only ' + numResultsFound + ' files out of all the selected have successfulluy been sent!<br/> ',
    'ar.result.table.envoi.success': 'The file has been successfully sent!',
    'ar.result.table.error.envoi.none': 'No file matches the conditions for sending!<br/> ',
    'ar.result.table.error.unauthorized': 'You are not authorized to perform this operation',
    'ar.result.table.error.select': 'Error selecting the files',

    'ar.report.title': 'Season report',
    'order.delete.error.dialogTitle': 'Order item deletion status',
    'order.delete.error.summary': (params: { count?: number } = {}) => {
      const count = params && typeof params.count === 'number' ? params.count : 0;
      return count === 1 ? '1 order item deletion failed.' : `${count} order item deletions failed.`;
    },
    'order.delete.success.summary': (params: { count?: number } = {}) => {
      const count = params && typeof params.count === 'number' ? params.count : 0;
      return count === 1 ? '1 order item deleted successfully.' : `${count} order items deleted successfully.`;
    },
    'order.delete.error.parcelIdNull': 'Parcel ID cannot be null.',
    'order.delete.error.parcelNotFound': 'Parcel not found.',
    'order.delete.error.noOrderItem': 'Parcel has no order item to delete.',
    'order.delete.error.adviceAlreadyRequested': () => 'Cannot delete order item: advice already requested.',
    'order.delete.error.passageAlreadyRestituted': () => 'Cannot delete order item: passage already restituted.',
    'order.delete.error.personalizedDateTooSoon': () =>
      'Cannot delete order item: personalized date must be more than 3 days in the future.',
    'order.delete.error.defaultWeekInPast': () => 'Cannot delete order item: default week is in the past.',
    'order.delete.error.defaultWeekTooClose': () => 'Cannot delete order item: default week is too close to delete.',
    'ar.report.filter': 'Season',
    'ar.report.button.telecharger': 'Download',
    'ar.report.table.exploitation': 'Farm',
    'planning.date.error.delivered': 'The field has already been delivered',
    'planning.multipleSelection.warning.title': 'Multiselect',
    'planning.multipleSelection.warning.message': 'Please note that all selected fields will be modified.',
    'planning.error.outsideCampaign.message': 'Outside the campaign days range',
    'planning.error.adviceDelivered.message': 'The advice was given and finished',
    'planning.error.multipleFailures.title': 'Multiple selection errors',
    'planning.error.singleParcel.title': 'Error in the field',
    'planning.batchUpdate.resultsTitle': 'Parcells batch update status',
    'planning.error.noDefaultWeek.message': 'default week has not been set',
    'planning.error.defaultWeekSuspendLimit.message':
      'You can only check the suspension box until the Friday before the default delivery week',
    'planning.error.suspendBeforeLimit.message':
      'You can only check the suspension box up to 3 days before the custom delivery date',
    'planning.error.parcels': 'field/s',
    'planning.success.dateUpdates': 'Fields with dates successfully updated.',
    'planning.error.failedDateUpdates':
      "fields couldn't be modified because the recommendation has already been delivered.",
    'planning.success.suspensions': 'Fields successfully updated due to suspension.',
    // Messages for planning matrix decision
    'planning.message.Title': 'Update status',
    'planning.suspend.error.pastWeek':
      "{{count}} fields couldn't be suspended because the planning date has already passed.",
    'planning.suspend.error.pastDate':
      "{{count}} fields couldn't be suspended because the planning date has already passed.",
    'planning.suspend.error.pastDateWeek':
      "{{count}} fields couldn't be suspended because the planning date has already passed.",
    'planning.suspend.error.restituted':
      "{{count}} fields couldn't be suspended because the recommendation has already been delivered.",
    'planning.reactivate.error.restituted':
      "{{count}} fields couldn't be reactivated because the recommendation has already been delivered.",
    'planning.reactivate.error.restituted.pastWeek':
      "{{count}} fields couldn't be reactivated because the recommendation has already been delivered and the planning date has already passed.",
    'planning.suspend.error.restituted.pastWeek':
      "{{count}} fields couldn't be suspended because the recommendation has already been delivered and the planning date has already passed.",
    'planning.suspend.success': 'The suspension has been taken into account.',
    'planning.reactivate.error.campaign':
      '{{count}} fields could not be reactivated because the end of the campaign was reached.',
    'planning.reactivate.success': 'The reactivation has been taken into account',
    'planning.reactivate.dateUnset.success':
      'The reactivation has been taken into account.<br>{{count}} fields were rescheduled on D+3',
    // Messages for planning matrix decision for singular messages
    'planning.suspend.error.pastWeek.singular':
      "{{count}} field couldn't be suspended because the planning date has already passed.",
    'planning.suspend.error.pastDate.singular':
      "{{count}} field couldn't be suspended because the planning date has already passed.",
    'planning.suspend.error.pastDateWeek.singular':
      "{{count}} field couldn't be suspended because the planning date has already passed.",
    'planning.suspend.error.restituted.singular':
      "{{count}} field couldn't be suspended because the recommendation has already been delivered.",
    'planning.reactivate.error.restituted.singular':
      "{{count}} field couldn't be reactivated because the recommendation has already been delivered.",
    'planning.reactivate.error.restituted.pastWeek.singular':
      "{{count}} field couldn't be reactivated because the recommendation has already been delivered and the planning date has already passed.",
    'planning.suspend.error.restituted.pastWeek.singular':
      "{{count}} field couldn't be suspended because the recommendation has already been delivered and the planning date has already passed.",
    'planning.suspend.success.singular': 'The suspension has been taken into account.',
    'planning.reactivate.error.campaign.singular':
      '{{count}} field could not be reactivated because the end of the campaign was reached.',
    'planning.reactivate.success.singular': 'The reactivation has been taken into account',
    'planning.reactivate.dateUnset.success.singular':
      'The reactivation has been taken into account.<br>{{count}} field were rescheduled on D+3',

    'planning.section': 'Update planning for',
    'planning.passage.choix': 'Choice of advice',
    'planning.button.back': 'Back',
    'planning.button.next': 'Next step',
    'planning.button.terminer': 'Finish',
    'planning.datepicker.parcelles.title': 'Choice of dates for fields',
    'planning.datepicker.exploitations.title': 'Choice of dates for farms',
    'planning.date.confirm': 'Change of date to',
    'planning.error.date': 'The desired date is not available',
    'planning.error.date.nonOuvre': '- You cannot select a non-working day',
    'planning.error.date.jourPasse': '- You cannot select a day in the past',
    'planning.error.date.delai': "- You must respect a deadline of 72 hours from today's date",
    'planning.error.date.campagne': '- The season is not open: Please contact customer support for more information',
    'planning.error.date.campagne.colza':
      '- The season is not open: Please contact customer support for more information',
    'planning.save': 'Save and confirm',
    'planning.culture.ble': 'Wheat',
    'planning.culture.orge': 'Barley',
    'planning.culture.colza': 'Rapeseed',
    'planning.label.ble.t1': 'Tillering (BBCH 21-29)',
    'planning.label.ble.t2': 'First node at 1cm (BBCH 30-31)',
    'planning.label.ble.2n': 'Second node (BBCH 32)',
    'planning.label.ble.t3': 'Flag leaf fully emerged (BBCH 39)',
    'planning.label.orge.t2': 'Beginning of stem elongation',
    'planning.label.orge.t3': 'End of stem elongation',
    'planning.label.colza.eh': 'Beginning of winter',
    'planning.label.colza.sh': 'Ending of winter',
    'planning.livraison.choix':
      'Would you like to enter the same delivery date for all the fields on the selected farms?',
    'planning.livraison.choix.oui': 'Yes',
    'planning.livraison.choix.non': 'No',
    'planning.error.parcelles': 'Error fetching fields',
    'planning.error.info': 'Error fetching information for the selected fields',
    'planning.error.unauthorized': 'You are not authorized to perform this operation',
    'planning.error.date.range': 'date from cannot be after date to',
    'planning.error.parcellesUpdate': 'Error fetch the fields after update',
    'planning.success': (dateStr: string, objectList: string) =>
      'The dates of the fields not yet processed have been changed to ' +
      dateStr +
      ' ' +
      objectList +
      '. Please refresh current page',
    'planning.error.campagne': 'Error fetching information on the season',

    'planning.info.colza.eh': 'For Early-Winter biomass estimation, november 30th is used as reference image date.',
    'planning.info.colza.sh':
      'For Late-Winter biomass estimation, if order is made after january 30th, january 30th is still used as reference image date.',

    'planning.exploitations.title': 'Choice of farms',
    'planning.exploitations.filter.exploitation': 'Farm',
    'planning.exploitations.filter.exploitation.placeholder': 'farm name',
    'planning.exploitations.filter.login.placeholder': 'login',
    'planning.exploitations.filter.cp.placeholder': 'postcode',
    'planning.exploitations.filter.distr': 'Organisation',
    'planning.choice.yes': 'Specified',
    'planning.choice.no': 'Not specified',
    'planning.exploitations.noExploitations': 'No farm to display',
    'planning.exploitations.nom': 'Name',
    'planning.exploitations.ville': 'City',
    'planning.exploitations.cp': 'Postcode',
    'planning.exploitations.dates': 'Dates entered',
    'planning.exploitations.complete': 'completed',
    'planning.exploitations.complete.title': 'All dates have been filled in',
    'planning.exploitations.nonComplete': 'not completed',
    'planning.exploitations.nonComplete.title': 'Not all dates are filled in',
    'planning.exploitations.error.noParcelles': 'No field is available for the chosen stage',
    'planning.exploitations.error.exploitations': 'Erreur fetching farms!',
    'planning.exploitations.error.selectExploitations': 'Error selecting farms',

    'planning.parcelles.title': 'Delivery planning for fields',
    'planning.parcelles.filter.parcelle.placeholder': 'field name',
    'planning.parcelles.filter.dateApres': 'Sowing date after ',
    'planning.parcelles.filter.dateApres.placeholder': 'dateAfter',
    'planning.parcelles.filter.dateAvant': 'Sowing date before',
    'planning.parcelles.filter.dateAvant.placeholder': 'dateBore',
    'planning.parcelles.filter.cp.placeholder': 'postcode',
    'planning.parcelles.filter.id': 'Id',
    'planning.parcelles.filter.id.placeholder': 'Id',
    'planning.parcelles.filter.culture': 'Crop',
    'planning.parcelles.filter.destination': 'Aim',
    'planning.parcelles.filter.distr': 'Organisation',
    'planning.parcelles.filter.date.personalized': 'personalized date',
    'planning.parcelles.filter.suspended': 'Suspended',
    'planning.parcelles.date.planning.before': 'Plannification date before',
    'planning.parcelles.date.planning.after': 'Plannification date after',
    'planning.parcelles.noParcelles': 'No field to display',
    'planning.parcelles.nom': 'Field',
    'planning.parcelles.cp': 'Postcode',
    'planning.parcelles.dateSemis': 'Sowing date',
    'planning.parcelles.destination': 'Aim',
    'planning.parcelles.culture': 'Crop',
    'planning.parcelles.dateLivraison': 'Delivery date',
    'planning.parcelles.week.default': 'default week',
    'planning.parcelles.actions': 'Actions',
    'planning.parcelles.action.suspend': 'Suspend',
    'planning.parcelles.button.search': 'Search',
    'planning.parcelles.button.reset': 'filters reset',
    'planning.parcelles.action.modifier.tooltip': 'Modify',
    'planning.parcelles.action.suspend.tooltip':
      'It is possible to suspend a restitution up to d-3 from the personalized date or end of the week preceding the default restitution week.',
    'planning.parcelles.aRenseigner': 'To fill',
    'planning.parcelles.button.modifierSelection': 'Edit selected',
    'planning.parcelles.pagination.page': 'page',
    'planning.parcelles.pagination.previous': 'previous',
    'planning.parcelles.pagination.next': 'next',
    'planning.parcelles.error.impossible.tooltip':
      'Error performing this operation. The delivery date is too close or is in the past',
    'planning.parcelles.error.parcelles': 'Error fetching fields',
    'planning.parcelles.error.noParcelles': 'No field is available for the chosen stage',
    'planning.parcelles.error.parcelles.2': 'Error fetching fields!',
    'planning.parcelles.error.selectParcelles': 'Error selecting fields',
    'planning.parcelles.error.cultures': 'Error fetching crops',

    'exports.section': 'Exports',
    'exports.section.intro': 'This page lists the various exports available to users.',
    'exports.commandes': (productName: string) => 'Export of orders ' + productName,
    'exports.commandes.fileName.part': 'orders',
    'exports.resultats': (productName: string) => 'Export of results ' + productName,
    'exports.resultats.fileName.part': 'results',
    'exports.summary': 'PDF Summary',
    'exports.summary.error': 'Error generating summary',
    'exports.summary.conflict.error':
      'An operating summary document is already being created.\nPlease wait for this document to be received by your email address {email}\nbefore requesting the generation of a new document.',
    'exports.summary.user.message':
      'Your request has been taken into account.\nThe operational summary document is being generated.\nYou will receive it by email at #mailuser within the hour.',
    'exports.telecharger': 'Download',
    'exports.campagne': 'Season',
    'exports.error.telecharger': 'Error downloading the file. Please contact customer support',

    'machininisme.info.1':
      'This page contains user manuals for consoles from several manufacturers. It is not exhaustive.',
    'machininisme.info.2':
      'You can also download our video tutorial below, which explains how to integrate the modulation files into your console.',
    'machininisme.tutoriel': 'Tutorial',
    'machininisme.button.telecharger': 'Download',
    'machininisme.noNotice': 'No manual to display',
    'machininisme.constructeur': 'Manufacturer',
    'machininisme.notice': 'User manual',
    'machininisme.error.telecharger': 'Error download file',
    'machininisme.error.unauthorized': 'You are not authorized to perform this operation',

    'campaign.status.configure': 'Configured',
    'campaign.status.nonConfigure': 'Not configured',

    'edit.choice.yes': 'Yes',
    'edit.choice.no': 'No',
    'edit.choice.none': 'None',
    'edit.choice.all': 'ALL',
    'edit.choice.all.fem': 'ALL',
    'edit.section.creation': 'Creation',
    'edit.section.creation.fieldview': 'Import Fieldview data',
    'edit.error.generic': 'There are errors in the form',
    'error.generic': 'An error occurred',
    'table.reference': 'Reference #',
    'table.itemsPerPage': 'Items per page :',

    'table.filter.button.autres': 'Other filters',
    'table.filter.button.reinit': 'Reset filters',
    'table.filter.button.reinit.singular': 'Reset filter',

    'button.edit': 'Edit',
    'button.save': 'Save',
    'button.modify': 'Edit',
    'button.confirm': 'Confirm',
    'button.cancel': 'Cancel',
    'button.fichier': 'Select a file',

    // Planning Visualizer
    'planning.visualizer.title': (currentYear: number) => `MY PLANNING <b>${currentYear}</b>`,
    'planning.visualizer.breadcrumb': (params) => `MY PLANNING ${params.year}`,
    'planning.visualizer.legend.defaultDate': 'Default Date',
    'planning.visualizer.legend.personalizedDate': 'Personalized Date',
    'planning.visualizer.legend.note': '*The number inside indicates the number of parcels',

    'planning.visualizer.filters.distributor': 'Distributor',
    'planning.visualizer.filters.advisorLogin': 'Advisor Login',
    'planning.visualizer.filters.exploitation': 'Exploitation',
    'planning.visualizer.filters.applyFilters': 'Apply Filters',
    'planning.visualizer.filters.resetFilters': 'Reset Filters',
    'planning.visualizer.filters.viewParcels': 'View All Parcels',
  }),
);

// pas de conversion
export const UNIT_CONVERTER = (baseUnit: string, value: number) => {
  return value;
};

export const CONVERTED_UNIT = (baseUnit: string, isPlural = false) => {
  return baseUnit;
};

// TODO a voir pour les pays si meme convention que UK et mettre les conventions 'en-uk' dans le en
export const NUMBER_FORMATTER = (n: number, options: any) => {
  if (n == null || n == undefined) {
    return '';
  }
  return n.toLocaleString('en', options);
};

export const DATE_FORMATTER = (d: Date) => {
  if (!d) {
    return '';
  }
  return d.toLocaleDateString('en');
};

export const PUNCTUATION_FORMATTER = (s: string) => {
  // pas d'espace avant les ponctuations
  return s;
};
